import { fork } from 'redux-saga/effects'
import SignUpSaga from './SignUpSaga'
import PaymentSaga from './PaymentSaga'


export default function* main(getStore) {
	yield [
    fork(SignUpSaga, getStore),
    fork(PaymentSaga, getStore),
  ];
}




// WEBPACK FOOTER //
// ./src/sagas/index.js